import React, { useEffect, useState, useMemo, useRef } from 'react'
import apiService from '../../service/apiService';
import "./index.css";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import OdishaDist from "../../Orissa.json";
import { geoCentroid } from "d3-geo";
import { Table } from "react-bootstrap";
import { Bar, Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, ArcElement } from "chart.js";
import { FaMale, FaFemale, FaUsers, FaCalendarAlt, FaChalkboardTeacher } from "react-icons/fa";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { ProgressBar } from "react-bootstrap";
import { Chart } from "react-google-charts";
import icardachangedlogo from "../../assets/images/icardachangedlogo.png";
import odishasasanlogo from "../../assets/images/odishasasanlogo.png";
import twblogo from "../../assets/images/twblogo.png";
import oiiplogo from "../../assets/images/oiiplogo.png";
import logo from '../../assets/images/icardalogo.png';
import mipdash from '../../assets/images/mipdash.png';
import fpcdash from '../../assets/images/fpcdash.png';
import farmerdash from '../../assets/images/farmerdash.png';
import pgdash from '../../assets/images/pgdash.png';
import cropintdash from '../../assets/images/cropintdash.png';
import imgbackground from "../../assets/images/imgbackground.png";
import { IMG_URL } from "../../service/ImageUrl";
import { format, parseISO } from "date-fns";


ChartJS.register(
  Title, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, ArcElement, ChartDataLabels
);

const DistrictMap = React.memo(({ districtDataMap }) => {
  const [hoveredDistrict, setHoveredDistrict] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  // ✅ same normalize
  const normalize = (name) =>
    name?.toLowerCase().replace(/\s+/g, "").trim();

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{
          scale: 6000,
          center: [84.5, 20.2],
        }}
        style={{ width: "100%", height: "100%" }}
      >
        <Geographies geography={OdishaDist}>
          {({ geographies, projection }) =>
            geographies.map((geo) => {
              const districtName = geo.properties.Dist_Name;
              const norm = normalize(districtName);

              const districtInfo = districtDataMap.get(norm);
              const isSelected = !!districtInfo;

              const centroid = geoCentroid(geo);
              const projectedCentroid = projection(centroid);

              return (
                <g key={geo.rsmKey}>
                  <Geography
                    geography={geo}
                    onMouseOver={() => {
                      if (districtInfo) setHoveredDistrict(districtInfo);
                    }}
                    onMouseOut={() => setHoveredDistrict(null)}
                    style={{
                      default: {
                        fill: isSelected ? "#FF5722" : "#0cae60ff",
                        outline: "none",
                        stroke: "#000000",
                      },
                      hover: {
                        fill: "#FFB74D",
                        outline: "none",
                        stroke: "#000000",
                      },
                      pressed: {
                        fill: "#FF5722",
                        outline: "none",
                        stroke: "#000000",
                      },
                    }}
                  />

                  {projectedCentroid && (
                    <text
                      x={projectedCentroid[0]}
                      y={projectedCentroid[1]}
                      textAnchor="middle"
                      style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        fill: "#000",
                        pointerEvents: "none",
                      }}
                    >
                      {districtName}
                    </text>
                  )}
                </g>
              );
            })
          }
        </Geographies>
      </ComposableMap>

      {hoveredDistrict && (
        <div
          style={{
            position: "absolute",
            top: mousePos.y + 10,
            left: mousePos.x + 10,
            padding: "10px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "6px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.25)",
            zIndex: 50,
            pointerEvents: "none", // prevent flicker
            width: "220px"
          }}
        >
          <h5 className="mt-0 text-success fw-bold">
            {hoveredDistrict.districtName}
          </h5>

          {/* <p className="m-0">
            Total Planned Area : <b>{hoveredDistrict.totalPlannedArea ?? 0}</b> ha
          </p>

          <p className="m-0">
            Total Cultivated Area : <b>{hoveredDistrict.totalCultivatedArea ?? 0}</b> ha
          </p> */}

          <p className="m-0">
            Total PG : <b>{hoveredDistrict.totalPg ?? 0}</b>
          </p>

          <p className="m-0">
            Total PG Member : <b>{hoveredDistrict.totalFarmer ?? 0}</b>
          </p>

          <p className="m-0">
            Total Pani Panchayat : <b>{hoveredDistrict.totalPaniPanchayat ?? 0}</b>
          </p>
        </div>
      )}
    </div>
  );
});

const YieldChart = ({ year }) => {
  const [yieldData, setYieldData] = useState(null);
  const [varietyData, setVarietyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [varietyLoading, setVarietyLoading] = useState(false);

  // Get current year as fallback
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const fetchVarietyData = async () => {
    const yearToUse = year || getCurrentYear();

    if (!yearToUse) return;

    setVarietyLoading(true);
    try {
      const response = await apiService.post(
        `/temp-upload/dashboard/cropvariety?year=${yearToUse}`
      );

      if (response?.data) {
        setVarietyData(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching variety data:", error);
      setVarietyData([]);
    } finally {
      setVarietyLoading(false);
    }
  };

  const fetchYieldData = async () => {
    setLoading(true);
    try {
      const response = await apiService.post(
        `/temp-upload/dashboard/distwiseachievement?year=${year}`
      );

      if (response?.data) {
        setYieldData(response.data);
      }
    } catch (error) {
      console.error("Error fetching yield data:", error);
      setYieldData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVarietyData();
    fetchYieldData();
  }, [year]);

  // Transform yield data for chart
  const transformYieldDataForChart = (apiData) => {
    if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
      return {
        labels: [],
        datasets: [
          {
            label: year || getCurrentYear().toString(),
            data: [],
            backgroundColor: [
              "rgba(3, 118, 63, 0.9)",
              "rgba(247, 179, 5, 0.9)",
              "rgba(237, 120, 27, 0.9)",
              "rgba(41, 128, 185, 0.9)",
              "rgba(142, 68, 173, 0.9)",
            ],
            barPercentage: 0.5,
            categoryPercentage: 0.6,
            borderRadius: { topLeft: 12, topRight: 12, bottomLeft: 0, bottomRight: 0 },
            borderSkipped: false,
          },
        ],
      };
    }

    // Transform based on your API response: { district: "Keonjhar", areaOfCoverage: 20 }
    const labels = apiData.data.map(item => item.district);
    const data = apiData.data.map(item => item.areaOfCoverage);

    return {
      labels: labels,
      datasets: [
        {
          label: `Area of Coverage (${year || getCurrentYear()})`,
          data: data,
          backgroundColor: [
            "rgba(3, 118, 63, 0.9)",
            "rgba(247, 179, 5, 0.9)",
            "rgba(237, 120, 27, 0.9)",
            "rgba(41, 128, 185, 0.9)",
            "rgba(142, 68, 173, 0.9)",
            "rgba(39, 174, 96, 0.9)",
            "rgba(230, 126, 34, 0.9)",
          ],
          barPercentage: 0.5,
          categoryPercentage: 0.6,
          borderRadius: { topLeft: 12, topRight: 12, bottomLeft: 0, bottomRight: 0 },
          borderSkipped: false,
        },
      ],
    };
  };

  // Simple variety data transformation - just use what comes from API
  const tableData = varietyData || [];

  const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: {
        color: "white",
        anchor: "center",
        rotation: -90,
        align: "center",
        font: { weight: "bold", size: 14 },
        formatter: (value) => (value % 1 === 0 ? value : value.toFixed(2)),
      },
      tooltip: {
        enabled: true,
        backgroundColor: "#03763f",
        titleFont: { weight: "bold" },
        callbacks: {
          label: function (context) {
            return `Area: ${context.parsed.y} ha`;
          }
        }
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: { display: false },
        title: {
          display: true,
          text: "Area (ha)",
          font: { weight: "bold", size: 14 }
        },
        ticks: {
          callback: function (value) {
            return value + ' ha';
          }
        }
      },
      x: {
        grid: { display: false },
        title: {
          display: true,
          text: "District",
          font: { weight: "bold", size: 14 }
        },
      },
    },
    animation: {
      duration: 1000,
      easing: "easeOutQuart",
    },
  };

  const chartData = transformYieldDataForChart(yieldData);

  return (
    <div className="col-12 d-flex">
      <div
        className="card shadow w-100"
        style={{
          borderRadius: "16px",
          background: "linear-gradient(135deg, #e8f6e4 0%, #ffffff 100%)",
          backdropFilter: "blur(6px)",
          border: "1px solid rgba(255,255,255,0.4)",
        }}
      >
        <div className="row g-4 align-items-stretch p-3">

          {/* LEFT CARD — District Wise Achievement */}
          <div className="col-6 d-flex">
            <div className="flex-fill d-flex flex-column">
              <h2
                className="text-center fw-bold mb-4 d-flex justify-content-center align-items-center gap-2"
                style={{ fontSize: "26px", color: "#03763f" }}
              >
                <i className="bi bi-bar-chart-fill" style={{ color: "#ed781b" }}></i>
                District Wise Crop Coverage (ha)
              </h2>

              <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                <div style={{ height: "320px", width: "100%" }}>
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div className="spinner-border text-success" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : yieldData && yieldData.data && yieldData.data.length > 0 ? (
                    <Bar data={chartData} options={options1} />
                  ) : (
                    <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                      No yield data available for {year || getCurrentYear()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT CARD — Varieties Table */}
          <div className="col-6 d-flex">
            <div
              className="card-custom p-2 shadow-sm flex-fill d-flex flex-column"
              style={{
                backgroundColor: "rgba(255,255,255,0.9)",
                borderRadius: "16px",
              }}
            >
              <h2
                className="text-center fw-bold text-success mb-4"
                style={{ fontSize: "26px" }}
              >
                Varieties
              </h2>

              <div
                className="flex-grow-1 overflow-auto p-3"
                style={{
                  maxHeight: "400px",
                  backgroundImage: `url(${imgbackground})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "12px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    borderRadius: "12px",
                    zIndex: 0,
                  }}
                ></div>

                <div className="px-4 pt-4 pb-0" style={{ position: "relative", zIndex: 1 }}>
                  {varietyLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                      <div className="spinner-border text-success" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : tableData.length > 0 ? (
                    <table className="table table-striped table-hover table-bordered mb-0">
                      <thead className="table-success">
                        <tr>
                          <th className="fw-bold">Crop</th>
                          <th className="fw-bold">Variety</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((item, index) => (
                          <tr key={index}>
                            <td className="fw-semibold">{item.crop}</td>
                            <td>{item.variety}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                      No variety data available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

const ThreeDBarChart = ({ data }) => {
  // 🧠 Modify data to include annotations for each numeric column
  const dataWithAnnotations = data.map((row, index) => {
    if (index === 0) {
      // Add annotation roles after each numeric column
      return [
        row[0],
        row[1], { role: "annotation" },
        row[2], { role: "annotation" },
        row[3], { role: "annotation" },
      ];
    } else {
      // Repeat each numeric value as its annotation text
      return [
        row[0],
        row[1], String(row[1]),
        row[2], String(row[2]),
        row[3], String(row[3]),
      ];
    }
  });

  const options = {
    chartArea: { width: "70%", height: "70%" },
    legend: { position: "top", alignment: "center" },
    bars: "horizontal",
    isStacked: true,
    series: {
      0: { color: "#03763f" }, // MIP
      1: { color: "#ed781b" }, // Male
      2: { color: "#f7b305" }, // Female
    },
    hAxis: {
      title: "no.",
      minValue: 0,
      gridlines: { count: 0 },
      baselineColor: "transparent",
    },
    vAxis: {
      title: "District",
      gridlines: { count: 0 },
      baselineColor: "transparent",
    },
    annotations: {
      alwaysOutside: false, // keep labels inside bars
      textStyle: {
        fontSize: 12,
        color: "#000",
        bold: true,
      },
    },
  };

  return (
    <Chart
      chartType="BarChart"
      width="100%"
      height="300px"
      data={dataWithAnnotations}
      options={options}
      loader={<div>Loading Chart...</div>}
    />
  );
};


function Index() {
  const [year, setYear] = useState("");
  const [yearimg, setYearImg] = useState(0);
  const [years, setYears] = useState([]);
  const [dists, setAllDists] = useState([]);
  const [dist, setDist] = useState("");
  const [block, setBlock] = useState(0);
  const [loading, setLoading] = useState(false);

  const [dashboardData, setDashboardData] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [season, setSeason] = useState(0);
  const [allcarddata, setAllCardData] = useState([]);
  const [allmapdata, setAllMapData] = useState([]);
  const [allareagraphdata, setAllAreaGraphData] = useState([]);
  const [allcolumndata, setAllColumnData] = useState([]);
  const [showDistDropdown, setShowDistDropdown] = useState(true);
  const [showBlockDropdown, setShowBlockDropdown] = useState(true);
  const [cropcuttingdata, setCropcuttingData] = useState([]);
  const [widgetdata, setWidgetData] = useState([]);
  const productionref = useRef(null);
  const cbref = useRef(null);
  const [verifiedImg, setVerifiedImg] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [lightbox, setLightbox] = useState({ open: false, image: null, location: "", date: "", index: 0 });
  const [climateData, setClimateData] = useState([]);
  const [subcbdata, setSubCBData] = useState({});


  // ✅ Define category state properly
  const [category, setCategory] = useState("");

  const [seedgraindata, setSeedGraindata] = useState({});

  const MeetingStats = () => {
    const [barData, setBarData] = useState([]);

    const fetchMeetingData = async () => {
      try {
        const url = `/temp-upload/dashboard/sensitizationmeeting?year=${year || ""}&district=${dist || ""}`;

        const response = await apiService.post(url);
        const data = response.data.data || [];

        // Prepare data for Bar chart
        const barChartData = [
          ["District", "MIP (no.)", "Male (no.)", "Female(no.)"]
        ];

        let maleCount = 0;
        let femaleCount = 0;

        data.forEach((item) => {
          barChartData.push([
            item.district,
            item.mip,
            item.male,
            item.female
          ]);
          maleCount += item.male;
          femaleCount += item.female;
        });

        setBarData(barChartData)
      } catch (error) {
        console.error("Error fetching meeting data:", error);
        setBarData([["District", "MIP (nos.)", "Participants (nos.)"]]);
      }
    };

    useEffect(() => {
      fetchMeetingData();
    }, [year, dist]);

    return (
      <div className="row align-items-stretch g-3">
        {/* 🗺️ LEFT: Map Section */}
        <div className="col-6 d-flex">
          <div className="card-custom p-3 shadow-sm flex-fill d-flex flex-column h-100">
            <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
              Geographical Presence
            </h2>

            {/* Map should take up remaining height */}
            <div className="flex-grow-1 d-flex align-items-center justify-content-center">
              <DistrictMap districtDataMap={districtDataMap} />
            </div>
          </div>
        </div>

        <div className="col-6 d-flex">
          <div className="card shadow p-4 flex-fill d-flex flex-column h-100">
            <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
MIP and Beneficiary details
            </h2>

            {/* ✅ Centered chart container */}
            <div
              className="flex-grow-1 d-flex align-items-center justify-content-center"
              style={{ minHeight: "300px", maxHeight: "350px" }}
            >
              <div
                style={{ width: "100%", height: "100%" }}
                className="d-flex align-items-center justify-content-center"
              >
                <ThreeDBarChart data={barData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleScroll = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      ref.current.classList.add("highlightdiv");

      setTimeout(() => {
        ref.current.classList.remove("highlightdiv");
      }, 2000);
    }
  };

  useEffect(() => {
    // console.log("it is calling more and more");
    const loginData = JSON.parse(localStorage.getItem("loginData")) || {};
    const districtId = loginData.districtId || 0;
    const blockId = loginData.blockId || 0;
    setDist(districtId);
    setBlock(blockId);

    if (districtId && blockId) {
      setShowDistDropdown(false);
      setShowBlockDropdown(false);
    } else if (districtId) {
      setShowDistDropdown(false);
      setShowBlockDropdown(true);
    } else if (blockId) {
      setShowDistDropdown(false);
      setShowBlockDropdown(false);
    } else {
      setShowDistDropdown(true);
      setShowBlockDropdown(true);
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await apiService.post("/dashboard/get-web-dashboard-data", {
        yearId: year,
        blockId: block,
        districtId: dist,
        seasonId: season
      });

      const data = response.data.body;
      console.log("response is : ", data);
      setAllCardData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const ClimateSmartChart = () => {
    const [climateData, setClimateData] = useState([]);
    const [loading, setLoading] = useState(true);

    // === Fetch Climate Smart Data ===
    const fetchClimateData = async () => {
      try {
        setLoading(true);
        const yearParam = year && year !== 0 ? `year=${year}` : "";
        const distParam = dist && dist !== 0 ? `&district=${dist}` : "";
        const url = `/temp-upload/dashboard/climatesmartcrop?${yearParam}${distParam}`;

        const response = await apiService.post(url);
        setClimateData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching climate smart data:", error);
        setClimateData([]);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchClimateData();
    }, [year, dist]);

    // === Desired Display Order ===
    const order = ["BS-FS", "FS-CS", "CS UPSCALING", "TL OUTREACH"];

    const processClimateData = (data) =>
      [...data]
        .map((item) => ({ ...item }))
        .sort((a, b) => {
          const aIndex = order.indexOf(a.type);
          const bIndex = order.indexOf(b.type);
          if (aIndex === -1 && bIndex === -1) return 0;
          if (aIndex === -1) return 1;
          if (bIndex === -1) return -1;
          return aIndex - bIndex;
        });

    // === Chart Options ===
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        datalabels: {
          color: "white",
          rotation: -90,
          anchor: "center",
          align: "center",
          font: { weight: "bold", size: 12 },
          formatter: (value) =>
            value % 1 === 0 ? value : value.toFixed(2),
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          grid: { display: false },
        },
        x: {
          grid: { display: false },
          ticks: {
            display: false,   // ⬅ Hides BS-FS / FS-CS / CS UPSCALING / TL OUTREACH
          },
        },
      },
    };

    const generateChartData = (item) => ({
      labels: [item.type],
      datasets: [
        {
          label: "Target",
          data: [item.target],
          backgroundColor: "#03763f",
          borderRadius: 8,
          barPercentage: 0.5,
        },
        {
          label: "Achievement",
          data: [item.achievement],
          backgroundColor: "#ed781b",
          borderRadius: 8,
          barPercentage: 0.5,
        },
      ],
    });

    return (
      <div className="col-12 mt-3 d-flex align-items-stretch">
        <div
          className="card p-4 w-100 h-100 shadow-lg"
          style={{
            background: "linear-gradient(120deg, #e7f5e6, #ffffffcc)",
            backdropFilter: "blur(8px)",
            borderRadius: "18px",
            border: "1px solid #d9e9d8",
          }}
        >
          {/* Title */}
          <h2
            className="text-center fw-bold text-success"
            style={{ fontSize: "28px" }}
          >
            Crop Intensification
          </h2>

          {/* Charts Row */}
          <div className="row mt-2">
            {loading ? (
              <div className="col-12 text-center" style={{ height: 300 }}>
                <div className="d-flex justify-content-center align-items-center h-100">
                  <span className="fw-bold text-muted">Loading...</span>
                </div>
              </div>
            ) : climateData.length === 0 ? (
              <div className="col-12 text-center" style={{ height: 300 }}>
                <div className="d-flex justify-content-center align-items-center h-100">
                  <span className="fw-bold text-danger">No data available</span>
                </div>
              </div>
            ) : (
              processClimateData(climateData).map((item, idx) => (
                <div key={idx} className="col-md-3 text-center">
                  <div
                    className="p-3 shadow-sm mb-3"
                    style={{
                      background: "rgba(255, 255, 255, 0.55)",
                      backdropFilter: "blur(6px)",
                      borderRadius: "14px",
                      transition: "0.3s",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    {/* Percentage Box */}
                    <div
                      className="d-inline-block px-3 py-1 rounded fw-bold text-white mb-2"
                      style={{
                        background: "linear-gradient(90deg,#03763f,#04a85d)",
                      }}
                    >
                      {item.overallPercentage ? `${item.overallPercentage}%` : "0%"}
                    </div>

                    <p className="fw-bold">{item.type}</p>

                    {/* Chart Box */}
                    <div style={{ height: 260 }}>
                      <Bar data={generateChartData(item)} options={options} />
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          {/* Global Legend */}
          <div className="d-flex justify-content-center gap-4 mt-1 fw-bold">
            <div className="d-flex align-items-center gap-2">
              <div style={{ width: 18, height: 18, background: "#03763f", borderRadius: 4 }}></div>
              <span>Target (ha)</span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div style={{ width: 18, height: 18, background: "#ed781b", borderRadius: 4 }}></div>
              <span>Achievement (ha)</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const fetchAreaChartData = async () => {
    try {
      const response = await apiService.post("/dashboard/get-web-dashboard-production-data", {
        yearId: year,
        blockId: block,
        districtId: dist,
        seasonId: season
      });

      const data = response.data.body || [];
      console.log("response is : ", data);
      setAllAreaGraphData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllAreaGraphData([]);
    }
  };

  const normalize = (name) =>
    name?.toLowerCase().replace(/\s+/g, "").trim();

  const fetchMapData = async () => {
    try {
      setLoading(true);
      const url = `/temp-upload/dashboard/mapprogram?year=${year || ""}`;

      const response = await apiService.post(url);
      console.log("map data is ", response.data);

      // Handle NEW API response structure: { year: "all", data: [...] }
      if (response.data && Array.isArray(response.data.data)) {
        setAllMapData(response.data.data);
      } else {
        setAllMapData([]);
      }

    } catch (error) {
      console.error("Error fetching map data:", error);
      setAllMapData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchImageVerificationData = async () => {
    try {
      const response = await apiService.get(
        `/image-verification/get-govt-dashboard-data?seasonId=${season}&yearId=${yearimg}`
      );

      const data = response.data.body || [];

      if (!data || data.length === 0) {
        setVerifiedImg([]);
        setSelectedCategory(null);
        return;
      }

      setVerifiedImg(data);
      setSelectedCategory(data[0]);

    } catch (error) {
      console.error("Error fetching data:", error);
      setVerifiedImg([]);
      setSelectedCategory(null);
    }
  };


  useEffect(() => {
    fetchMapData();
  }, [year]);

  useEffect(() => {
    fetchImageVerificationData();
  }, [yearimg]);

  const openLightbox = (image, location, date, index) => {
    setLightbox({ open: true, image, location, date, index });
  };
  const closeLightbox = () => {
    setLightbox({ open: false, image: null, location: "", date: "", index: 0 });
  };
  const changeImage = (direction) => {
    let newIndex = lightbox.index + direction;
    if (newIndex >= selectedCategory.images.length) newIndex = 0;
    if (newIndex < 0) newIndex = selectedCategory.images.length - 1;
    setLightbox({ ...lightbox, image: selectedCategory.images[newIndex].url, location: selectedCategory.images[newIndex].location, date: selectedCategory.images[newIndex].date, index: newIndex });
  };

  const districtDataMap = useMemo(() => {
    const map = new Map();

    allmapdata.forEach((item) => {
      const norm = normalize(item.district); // Use 'district' not 'districtName'

      // Transform NEW API data to match what DistrictMap expects
      map.set(norm, {
        districtName: item.district, // Map 'district' to 'districtName'
        // totalPlannedArea: item.data?.totalPlannedArea || 0,
        // totalCultivatedArea: item.data?.totalCultivatedArea || 0,
        totalPg: item.data?.totalPg || 0, // Now available in new API
        totalFarmer: item.data?.totalPgMembers || 0, // Map 'totalPgMembers' to 'totalFarmer'
        totalPaniPanchayat: item.data?.totalPaniPanchayat || 0
      });
    });

    return map;
  }, [allmapdata]);

  const fetchDashboardData = async () => {
    setLoading(true);
    setDashboardData([]);
    try {
      const response = await apiService.post(
        `/temp-upload/dashboardtargetandachievement?year=${year || ""}&district=${dist || ""}`
      );

      if (response?.data?.data) {
        setDashboardData(response.data.data);
      } else {
        setDashboardData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setDashboardData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSeedGrainData = async () => {
    try {
      setLoading(true);
      const url = `/temp-upload/dashboard/seedgrain?year=${year || ""}&district=${dist || ""}`;

      const response = await apiService.post(url);
      console.log("seedgrain response is ", response.data);
      setSeedGraindata(response.data || {});
    } catch (error) {
      console.error("Error fetching climate smart data:", error);
      setSeedGraindata({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchSeedGrainData();
  }, [year, dist]);

  const fetchWidgetData = async () => {
    setLoading(true);
    setWidgetData([]);
    try {
      const response = await apiService.get(
        `/entity-counts/get-all-index-data?district=${dist || ""}`
      );

      if (response?.data?.body) {
        setWidgetData(response.data.body);
      } else {
        setWidgetData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setWidgetData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetData();
  }, [dist]);

  const getDataByName = (name) => {
    return dashboardData.find((item) => item.name === name) || { achieved: 0, target: 0, male: 0, female: 0, mip: 0 };
  };

  const farmerFieldDays = getDataByName("Farmer Field Day");

  const fetchColumnData = async () => {
    try {
      const response = await apiService.post("/dashboard/eventcounts", {
        yearId: year,
        blockId: block,
        districtId: dist,
        seasonId: season
      });

      const data = response.data || [];
      console.log("response is : ", data);
      setAllColumnData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllAreaGraphData([]);
    }
  };

  const fetchCropCuttingData = async () => {
    try {
      const response = await apiService.post("/dashboard/crop-cutting-graph", {
        yearId: year,
        blockId: block,
        districtId: dist,
        seasonId: season
      });

      const data = response.data.body || [];
      setCropcuttingData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setCropcuttingData([]);
    }
  };

  useEffect(() => {
    if (year) {
      const delayFetch = setTimeout(() => {
        fetchData();
        fetchAreaChartData();
        fetchColumnData();
        fetchCropCuttingData();
      }, 300);

      return () => clearTimeout(delayFetch);
    }
  }, [year, dist, block, season]);

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      const fetchedYears = response.data;
      setYears(fetchedYears);

    } catch (error) { console.error("Error fetching years:", error); }
  };

  const fetchAllDist = async () => {
    try {
      const response = await apiService.get('/districts/get-all');
      setAllDists(response.data);
    } catch (error) { console.error('Error fetching seeds:', error); }
  };

  const fetchBlocks = async () => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${dist}`);
      setBlocks(response.data.body.blocks);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  }

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  useEffect(() => {
    fetchYears();
    fetchAllDist();
    fetchSeasons();
  }, []);

  useEffect(() => {
    if (dist > 0) {
      fetchBlocks();
    }
  }, [dist]);

  const getChartData = (typeName) => {
    const typeData = getTypeData(typeName);

    return {
      labels: ["Achieved", "Remaining"],
      datasets: [
        {
          label: typeName || capacityData.typeDetails[0]?.name || "Capacity Building",
          data: [typeData.achieved, Math.max(0, typeData.target - typeData.achieved)],
          backgroundColor: ["#ed781b", "#03763f"],
          hoverBackgroundColor: ["#e99857ff", "#0fd777ff"],
        },
      ],
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
        },
      },
      datalabels: {
        color: "#fff",
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value) => {
          return value % 1 === 0 ? value : value.toFixed(2);
        },
        anchor: "center",
        align: "center",
      },
    },
  };

  const fetchClimateData = async () => {
    try {
      setLoading(true);

      const yearParam = year && year !== 0 ? `year=${year}` : "";
      const distParam = dist && dist !== 0 ? `&district=${dist}` : "";
      const url = `/temp-upload/dashboard/climatesmartcrop?${yearParam}${distParam}`;

      const response = await apiService.post(url);

      setClimateData(response.data.data || []); // ✅ sets array of objects
    }
    catch (error) {
      console.error("Error fetching climate smart data:", error);
      setClimateData([]);
    }
    finally {
      setLoading(false);
    }
  };
  const fetchsubCBData = async () => {
    try {
      setLoading(true);
      const url = `/temp-upload/dashboard/cbsubtype?year=${year || ""}&district=${dist || ""}`;
      const response = await apiService.post(url);

      setSubCBData(response.data.data || {}); // ✅ sets array of objects
    }
    catch (error) {
      console.error("Error fetching cb sub type data data:", error);
      setSubCBData({});
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchClimateData();
    fetchsubCBData();
  }, [year, dist]);

  const dataToShow = subcbdata[category] || [];

  const getParticipantData = (cat) => {
    return getTypeData(cat);
  };

  const climateTotals = useMemo(() => {
    if (!climateData || climateData.length === 0) {
      return { target: 0, achievement: 0 };
    }

    const totalTarget = climateData.reduce((sum, item) => sum + (item.target || 0), 0);
    const totalAchievement = climateData.reduce((sum, item) => sum + (item.achievement || 0), 0);

    return {
      target: totalTarget,
      achievement: totalAchievement
    };
  }, [climateData]);

  const handleCardClick = (type) => {
    setCategory(type);
    handleScrollcb(cbref);
  };
  const handleScrollcb = (ref) => {
    if (ref.current) {
      const element = ref.current;

      // Calculate position with proper offset
      const yOffset = -100; // Adjust this value
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      console.log('Current scrollY:', window.scrollY);
      console.log('Target scrollY:', y);

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });

      // Visual feedback
      element.style.boxShadow = '0 0 0 3px #03763f';
      element.style.transition = 'box-shadow 0.3s ease';

      setTimeout(() => {
        if (element) {
          element.style.boxShadow = '';
        }
      }, 2000);
    }
  };
  const [capacityData, setCapacityData] = useState({
    overall: {},
    typeDetails: []
  });

  useEffect(() => {
    const fetchCapacityData = async () => {
      try {
        const response = await apiService.post(
          `/temp-upload/dashboard/capacitybuilding?year=${year || ""}&district=${dist || ""}&type=`
        );

        if (response?.data) {
          const typeDetails = response.data.typeDetails || [];

          setCapacityData({
            overall: {
              target: response.data.target,
              achieved: response.data.achieved,
              participants: response.data.participants
            },
            typeDetails: typeDetails
          });

          // ✅ Set the first category from API response
          if (typeDetails.length > 0 && !category) {
            setCategory(typeDetails[0].name);
          }
        }
      } catch (error) {
        console.error("Error fetching capacity building data:", error);
      }
    };

    fetchCapacityData();
  }, [dist, year]);

  // Helper to get data for a specific type
  const getTypeData = (typeName) => {
    if (!typeName && capacityData.typeDetails.length > 0) {
      // If no category selected, use the first one from API
      typeName = capacityData.typeDetails[0].name;
    }

    const typeData = capacityData.typeDetails.find(item =>
      item.name.toLowerCase() === typeName.toLowerCase()
    );

    if (typeName && typeName.toLowerCase() === "Farmer Field Days".toLowerCase()) {
      return {
        target: farmerFieldDays?.target || 0,
        achieved: farmerFieldDays?.achieved || 0,
        male: farmerFieldDays?.male || 0,
        female: farmerFieldDays?.female || 0,
        total: (farmerFieldDays?.male + farmerFieldDays?.female) || 0,
        mip: farmerFieldDays?.mip,
      };
    }

    if (typeData) {
      return {
        target: typeData.target,
        achieved: typeData.achieved,
        male: typeData.participants?.male || 0,
        female: typeData.participants?.female || 0,
        total: typeData.participants?.total || 0,
        mip: typeData.participants?.mip || 0
      };
    }

    return { target: 0, achieved: 0, male: 0, female: 0, total: 0, mip: 0 };
  };

  // Add these states
  const [seedData, setSeedData] = useState("");
  const [grainData, setGrainData] = useState("");
  const [seedTotals, setSeedTotals] = useState({});
  const [grainTotals, setGrainTotals] = useState({});

  // Fetch Seed Data
  useEffect(() => {
    const fetchSeedData = async () => {
      try {
        const response = await apiService.post(
          `/temp-upload/dashboard/seeddata?year=&district=`
        );

        if (response?.data?.data) {
          setSeedData(response.data.data);
          // calculateSeedTotals(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching seed data:", error);
        setSeedData("");
        // setSeedTotals({});
      }
    };

    fetchSeedData();
  }, [year, dist]);

  // Fetch Grain Data
  useEffect(() => {
    const fetchGrainData = async () => {
      try {
        const response = await apiService.post(
          `/temp-upload/dashboard/graindata?year=&district=`
        );

        if (response?.data?.data) {
          setGrainData(response.data.data);
          // calculateGrainTotals(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching grain data:", error);
        setGrainData("");
        // setGrainTotals({});
      }
    };

    fetchGrainData();
  }, [year, dist]);

  // Calculate Seed Data Totals
  const calculateSeedTotals = (data) => {
    if (!data || data.length === 0) {
      setSeedTotals({
        value: 0,
        totalSale: 0,
        totalIncrementalValue: 0,
        linkageToOssc: 0,
        linkageToIcarda: 0,
        linkageToOthersAgency: 0
      });
      return;
    }

    const totals = data.reduce((acc, item) => ({
      value: acc.value + (item.value || 0),
      totalSale: acc.totalSale + (item.totalSale || 0),
      totalIncrementalValue: acc.totalIncrementalValue + (item.totalIncrementalValue || 0),
      linkageToOssc: acc.linkageToOssc + (item.linkageToOssc || 0),
      linkageToIcarda: acc.linkageToIcarda + (item.linkageToIcarda || 0),
      linkageToOthersAgency: acc.linkageToOthersAgency + (item.linkageToOthersAgency || 0)
    }), {
      value: 0,
      totalSale: 0,
      totalIncrementalValue: 0,
      linkageToOssc: 0,
      linkageToIcarda: 0,
      linkageToOthersAgency: 0
    });

    setSeedTotals(totals);
  };

  // Calculate Grain Data Totals
  const calculateGrainTotals = (data) => {
    if (!data || data.length === 0) {
      setGrainTotals({
        producerGroupCount: 0,
        farmerCount: 0,
        surplusQuantity: 0,
        costOfProduceAtMsp: 0,
        totalSale: 0,
        totalIncrementalValue: 0
      });
      return;
    }

    const totals = data.reduce((acc, item) => ({
      producerGroupCount: acc.producerGroupCount + (item.producerGroupCount || 0),
      farmerCount: acc.farmerCount + (item.farmerCount || 0),
      surplusQuantity: acc.surplusQuantity + (item.surplusQuantity || 0),
      costOfProduceAtMsp: acc.costOfProduceAtMsp + (item.costOfProduceAtMsp || 0),
      totalSale: acc.totalSale + (item.totalSale || 0),
      totalIncrementalValue: acc.totalIncrementalValue + (item.totalIncrementalValue || 0)
    }), {
      producerGroupCount: 0,
      farmerCount: 0,
      surplusQuantity: 0,
      costOfProduceAtMsp: 0,
      totalSale: 0,
      totalIncrementalValue: 0
    });

    setGrainTotals(totals);
  };

  const formatNumber = (num) => {
    const value = Number(num);
    return Number.isInteger(value) ? value : value.toFixed(2);
  };

  const capacityOrder = [
    "Awareness Meeting",
    "Cluster Training",
    "Exposure Visit",
  ];

  const headerTitleMap = {
    "Awareness Meeting": "Program Type (#)",
    "Cluster Training": "Training Type (#)",
    "Exposure Visit": "Participant Type (#)",
    "Farmer Field Days": "Participant Type (#)",
  };

  const headerTitle = headerTitleMap[category] || "Coverage Nos.";

  return (
    <div className="container-fluid p-4" style={{ maxHeight: "100vh", overflowX: "auto", backgroundColor: "#f8f9fa" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold mb-0 col-1">
          {/* <img
            src={logo}
            alt="Logo"
            className="logo"
            style={{ width: '60px', height: 'auto' }}
          /> */}
        </h3>
        <div className="d-flex align-items-center col-4 mb-3">
          <img src={logo} alt="Logo" className="logo" style={{ width: '60px', height: 'auto' }} />
          <img src={twblogo} alt="icon2" style={{ height: "50px", width: "auto", marginRight: "15px" }} />
          <img src={oiiplogo} alt="icon1" style={{ height: "50px", width: "auto", marginRight: "15px" }} />
          <img src={odishasasanlogo} alt="icon3" style={{ height: "50px", width: "auto", marginRight: "15px" }} />
          {/* <img src={icardachangedlogo} alt="icon4" style={{ height: "50px", width: "auto" }} /> */}
        </div>

        <div className="col-4 d-flex flex-wrap justify-content-end">
          {/* Year Dropdown */}
          <select
            className="form-select form-select-md"
            style={{ width: "150px" }}
            value={year}
            onChange={(e) => { setYear(e.target.value); setYearImg(e.target.options[e.target.selectedIndex].dataset.id); }}
          >
            <option value="">All Year</option>   {/* empty instead of "all" */}
            {years.map((yr) => (
              <option key={yr.yearId} value={yr.yearValue} data-id={yr.yearId}>
                {yr.yearValue}
              </option>
            ))}
          </select>

          {/* District Dropdown */}
          <select
            className="form-select form-select-md"
            style={{ width: "150px" }}
            value={dist}
            onChange={(e) => setDist(e.target.value)}
          >
            <option value="">All District</option> {/* empty instead of "all" */}
            {dists.map((dst) => (
              <option key={dst.districtId} value={dst.districtName}>
                {dst.districtName}
              </option>
            ))}
          </select>

          {/* Block Dropdown */}
          {/* {showBlockDropdown && (
            <div className="col-md-auto col-sm-12">
              <select className="form-select form-select-md" style={{ width: "150px" }} value={block} onChange={(e) => { setBlock(Number(e.target.value)); }}>
                <option value={0}>Select All Block</option>
                {blocks.map((blk) => (
                  <option key={blk.blockId} value={blk.blockId}>{blk.blockName}</option>
                ))}
              </select>
            </div>
          )} */}
          {/* Season Dropdown */}
          {/* <div className="col-md-auto col-sm-12">
            <select className="form-select form-select-md" style={{ width: "150px" }} value={season} onChange={(e) => { setSeason(Number(e.target.value)); }}>
              <option value={0}>Select All Season</option>
              {seasons.map((ses) => (
                <option key={ses.seasonId} value={ses.seasonId}>{ses.seasonName}</option>
              ))}
            </select>
          </div> */}
        </div>
      </div>
      <div className="row g-3">
        <div className="col-7">
          <div
            className="card-custom position-relative d-flex flex-column justify-content-between p-4 h-100"
            style={{ minHeight: "180px", cursor: "pointer" }}
            onClick={() => handleScroll(productionref)}
          >
            <div className="d-flex w-100 justify-content-between">
              <div className="d-flex align-items-center">
                <img
                  src={cropintdash}
                  alt="Crop Intensification"
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "contain",
                  }}
                  className='mr-3'
                />
                <h2 className="mb-0 fw-bold text-success" style={{ lineHeight: "1", fontSize: "26px" }}>
                  Crop Intensification (ha)
                </h2>
              </div>
            </div>
            {/* ✅ Main Achievement Value */}
            <div className="text-center">
              <h4 className="mb-0 fw-bold" style={{ color: "#ed781b" }}>
                {formatNumber(climateTotals.achievement ?? 0)} /{" "}
                <span style={{ color: "#03763f" }}>
                  {formatNumber(climateTotals?.target ?? 4980)}
                </span>
              </h4>

            </div>

            {/* ✅ Progress Bar */}
            <div style={{ backgroundColor: "#ffffff", borderRadius: "5px", overflow: "hidden", height: "20px", }}>
              <ProgressBar
                now={(climateTotals.achievement / (climateTotals?.target || 1)) * 100}
                label={`${Math.round(
                  (climateTotals.achievement / (climateTotals?.target || 1)) * 100
                )}%`}
                variant="warning"
                style={{
                  backgroundColor: "#03763f", // filled portion color
                  color: "#ffffff",           // label text
                  height: "100%",             // match outer div height
                }}
              />
            </div>
            {/* ✅ Climate Data 3 Columns (Each centered, 3 lines) */}
            <div className="row text-center mt-3">
              {climateData
                ?.map((item) => {
                  return { ...item };
                })
                .sort((a, b) => {
                  const order = ["BS-FS", "FS-CS", "CS UPSCALING", "TL OUTREACH"];
                  const aIndex = order.indexOf(a.type);
                  const bIndex = order.indexOf(b.type);

                  if (aIndex === -1 && bIndex === -1) return 0;
                  if (aIndex === -1) return 1;
                  if (bIndex === -1) return -1;
                  return aIndex - bIndex;
                })
                .map((item, index) => (
                  <div
                    key={index}
                    className="col-3 d-flex align-items-center justify-content-center"
                  >
                    <div
                      style={{
                        width: "100%",
                        minHeight: "100px",
                        borderRadius: "18px",
                        background: "rgba(255, 255, 255, 0.65)",      // Glass Effect
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                        border: "2px solid #03763f",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: "10px",
                        transition: "0.35s ease",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",      // Soft shadow
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.06)")}
                      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    >
                      {/* ICON */}
                      <i
                        className="fas fa-seedling mb-2"
                        style={{ fontSize: "24px", color: "#03763f" }}
                      ></i>

                      {/* TITLE */}
                      <div className="fw-bold text-success" style={{ fontSize: "16px" }}>
                        {item.type}
                      </div>

                      {/* NUMBERS */}
                      <div className="fw-bold" style={{ fontSize: "14px", color: "#333" }}>
                        {formatNumber(item.achievement)} / {formatNumber(item.target)}
                      </div>

                      {/* PERCENT */}
                      <div
                        style={{
                          color: "#ed781b",
                          fontWeight: "700",
                          fontSize: "14px",
                          marginTop: "4px",
                        }}
                      >
                        {item.overallPercentage}%
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="col-5">
          <div
            className="position-relative d-flex flex-column justify-content-between h-100"
            style={{
              minHeight: "240px", // slightly taller for better balance
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
          >
            {/* ✅ Grid layout filling full card height */}
            <div
              className="d-flex flex-wrap justify-content-between align-content-between h-100"
              style={{
                backgroundColor: "#eaf5e0",
                borderRadius: "10px",
                padding: "10px",
              }}
            >
              {/* PGs */}
              <div
                className="d-flex align-items-center justify-content-between mb-2 px-4"
                style={{
                  width: "49%",
                  height: "48%", // each box takes half vertically
                  backgroundColor: "#d4edc9",
                  borderRadius: "8px",
                  padding: "10px",
                  // cursor: "pointer",
                  transition: "0.2s ease-in-out",
                }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   navigate("/producergroup");
                // }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#c7e6b8")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#d4edc9")
                }
              >
                <img
                  src={pgdash}
                  alt="PGs"
                  style={{ width: "60px", height: "60px", objectFit: "contain" }}
                />
                <div className="text-end flex-grow-1">
                  <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                    # {widgetdata.totalPGs || 0}
                  </h5>
                  <small className='fw-bold' style={{ color: "#33691e", fontSize: "15px" }}>
                    Producer Group
                  </small>
                </div>
              </div>

              {/* Farmers */}
              <div
                className="d-flex align-items-center justify-content-between mb-2 px-4"
                style={{
                  width: "49%",
                  height: "48%",
                  backgroundColor: "#d4edc9",
                  borderRadius: "8px",
                  padding: "10px",
                  // cursor: "pointer",
                  transition: "0.2s ease-in-out",
                }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   navigate("/farmermanage");
                // }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#c7e6b8")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#d4edc9")
                }
              >
                <img
                  src={farmerdash}
                  alt="Farmers"
                  style={{ width: "60px", height: "60px", objectFit: "contain" }}
                />
                <div className="text-end flex-grow-1">
                  <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                    #{widgetdata.totalPGMembers || 0}
                  </h5>
                  <small className='fw-bold' style={{ color: "#33691e", fontSize: "15px" }}>
                    Producer Group Member
                  </small>
                </div>
              </div>

              {/* FPCs */}
              <div
                className="d-flex align-items-center justify-content-between mb-2 px-4"
                style={{
                  width: "49%",
                  height: "48%",
                  backgroundColor: "#d4edc9",
                  borderRadius: "8px",
                  padding: "10px",
                  // cursor: "pointer",
                  transition: "0.2s ease-in-out",
                }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   navigate("/farmerproducercompany");
                // }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#c7e6b8")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#d4edc9")
                }
              >
                <img
                  src={fpcdash}
                  alt="FPCs"
                  style={{ width: "60px", height: "60px", objectFit: "contain" }}
                />
                <div className="text-end flex-grow-1">
                  <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                    # {widgetdata.totalFPCs || 0}
                  </h5>
                  <small className='fw-bold' style={{ color: "#33691e", fontSize: "15px" }}>
                    Farmer Producer Company
                  </small>
                </div>
              </div>

              {/* MIPs */}
              <div
                className="d-flex align-items-center justify-content-between mb-2 px-4"
                style={{
                  width: "49%",
                  height: "48%",
                  backgroundColor: "#d4edc9",
                  borderRadius: "8px",
                  padding: "10px",
                  // cursor: "pointer",
                  transition: "0.2s ease-in-out",
                }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   navigate("/mipdata");
                // }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#c7e6b8")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#d4edc9")
                }
              >
                <img
                  src={mipdash}
                  alt="MIPs"
                  style={{ width: "60px", height: "60px", objectFit: "contain" }}
                />
                <div className="text-end flex-grow-1">
                  <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                    # {widgetdata.totalMIPs || 0}
                  </h5>
                  <small className='fw-bold' style={{ color: "#33691e", fontSize: "15px" }}>
                    Minor Irrigation Project (MIP)
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
      <div className="row align-items-stretch mb-3" ref={productionref}>
        <ClimateSmartChart />
      </div>
      <div className='mb-3'>
        <MeetingStats />
      </div>
      <div className="row">
        <YieldChart year={year} />
      </div>
      <div className="card shadow p-4 w-100 h-100" style={{ backgroundColor: "#eaf5e0" }}>
        <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
          Capacity Building
        </h2>
        <div className="row g-3">
          {capacityData.typeDetails
            .slice()
            .sort((a, b) => {
              const aIndex = capacityOrder.indexOf(a.name);
              const bIndex = capacityOrder.indexOf(b.name);

              if (aIndex === -1 && bIndex === -1) return 0;
              if (aIndex === -1) return 1;
              if (bIndex === -1) return -1;
              return aIndex - bIndex;
            })
            .map((type, index) => (
              <div key={index} className="col-3">
                <div
                  className="d-flex flex-column p-4 h-100"
                  style={{
                    cursor: "pointer",
                    borderRadius: "18px",
                    background: "#c3f3c9",        // Glass
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    border:
                      category === type.name
                        ? "3px solid #03763f"
                        : "1px solid rgba(255, 255, 255, 0.5)",
                    transition: "0.35s ease",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  }}
                  onClick={() => handleCardClick(type.name)}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <div className="d-flex w-100 justify-content-between">
                    <div className="d-flex">
                      <FaCalendarAlt
                        size={30}
                        className="me-3"
                        style={{ color: "#f7b305" }}
                      />
                      <h6 className="mb-0 fw-bold">{type.name}</h6>
                    </div>
                  </div>

                  <div className="text-center my-2">
                    <h4 className="mb-0 fw-bold">
                      <span style={{ color: "#ed781b" }}>{type.achieved}</span> /{" "}
                      <span style={{ color: "#03763f" }}>{type.target}</span>
                    </h4>
                  </div>

                  <div className="mt-auto" style={{ backgroundColor: "#ffffff", borderRadius: "5px", overflow: "hidden", height: "20px", }}>
                    <ProgressBar
                      now={(type.achieved / (type.target || 1)) * 100}
                      label={`${Math.round(
                        (type.achieved / (type.target || 1)) * 100
                      )}%`}
                      variant="warning"
                      style={{
                        backgroundColor: "#03763f",
                        color: "#ffffff",
                        height: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}

          {/* STATIC CARD - Farmer Field Days */}
          <div className="col-3">
            <div
              className="d-flex flex-column p-4 h-100"
              style={{
                borderRadius: "18px",
                background: "#c3f3c9",          // Glass
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                border:
                  category === "Farmer Field Days"
                    ? "3px solid #03763f"
                    : "1px solid rgba(255, 255, 255, 0.5)",
                transition: "0.35s ease",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                cursor: "pointer",
              }}
              onClick={() => { setCategory("Farmer Field Days"); handleScrollcb(cbref); }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <div className="d-flex w-100 justify-content-between">
                <div className="d-flex">
                  <FaChalkboardTeacher
                    size={30}
                    className="me-3"
                    style={{ color: "#f7b305" }}
                  />
                  <h6 className="mb-0 fw-bold">Farmer Field Days</h6>
                </div>
                {/* <Link to="/ffd">
                  <FaArrowCircleRight
                    size={25}
                    style={{ cursor: "pointer", color: "#f7b305" }}
                  />
                </Link> */}
              </div>

              <div className="text-center my-2">
                <h4 className="mb-0 fw-bold">
                  <span style={{ color: "#ed781b" }}>{farmerFieldDays.achieved}</span> /{" "}
                  <span style={{ color: "#03763f" }}>{farmerFieldDays.target}</span>
                </h4>
              </div>

              <div className="mt-auto" style={{ backgroundColor: "#ffffff", borderRadius: "5px", overflow: "hidden", height: "20px", }}>
                <ProgressBar
                  now={(farmerFieldDays.achieved / (farmerFieldDays.target || 1)) * 100}
                  label={`${Math.round(
                    (farmerFieldDays.achieved / (farmerFieldDays.target || 1)) * 100
                  )}%`}
                  variant="warning"
                  style={{
                    backgroundColor: "#03763f",
                    color: "#ffffff",
                    height: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="row align-items-stretch mb-3" ref={cbref}>
        <div className="col-12 d-flex align-items-stretch">
          <div className="card shadow p-4 w-100 h-100" style={{ backgroundColor: "#eaf5e0" }}>

            {/* Dynamic Title - Will show first API item initially */}
            <div className="row mb-4 align-items-center">
              <div className="col-12 text-center">
                <h4 className="fw-bold text-success mb-0">
                  {category || (capacityData.typeDetails[0]?.name || "Capacity Building")}
                </h4>
              </div>
            </div>

            <div className="row align-items-stretch">
              {/* LEFT SECTION (Chart + Participants) */}
              <div className="col-8 d-flex">
                <div
                  className="d-flex justify-content-between align-items-center flex-fill p-3 rounded"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.7)",
                    border: "1px solid #ddd",
                    borderRadius: "10px",
                  }}
                >
                  {/* LEFT SIDE — Doughnut Chart */}
                  <div className="text-center d-flex flex-column justify-content-center align-items-center flex-fill">
                    <p className="text-success fw-bold mb-2">
                      Target: {getParticipantData(category)?.target ?? "-"}
                    </p>

                    <div
                      style={{
                        width: "250px",
                        height: "250px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Doughnut
                        data={getChartData(category)}
                        options={options}
                      />
                    </div>
                  </div>

                  {/* RIGHT SIDE — Participants Box */}
                  <div
                    className="border rounded bg-light d-flex flex-column justify-content-center align-items-center"
                    style={{
                      width: "320px",
                      height: "100%",
                      minHeight: "250px",
                    }}
                  >
                    <h5 className="fw-bold text-center mb-3 d-flex align-items-center justify-content-center">
                      Participant ( <FaUsers size={20} className="text-success mx-1" style={{ verticalAlign: 'middle' }} /> {getParticipantData(category)?.total ?? "-"} )
                    </h5>
                    <div className="row text-center w-100">
                      <div className="col-6 text-center">
                        <FaMale size={36} className="text-primary mb-2" />

                        <div className="fw-bold fs-5">
                          {getParticipantData(category)?.male ?? "-"}
                        </div>

                        {/* <small className="text-muted fs-6">Male</small> */}

                        <div className="text-primary fs-6 fw-semibold">
                          {getParticipantData(category)?.total > 0 &&
                            getParticipantData(category)?.male != null
                            ? `${(
                              (getParticipantData(category)?.male /
                                getParticipantData(category)?.total) *
                              100
                            ).toFixed(1)}%`
                            : "-"}
                        </div>
                      </div>

                      <div className="col-6 text-center">
                        <FaFemale size={36} style={{ color: "#e91e63" }}  className="mb-2" />

                        <div className="fw-bold fs-5">
                          {getParticipantData(category)?.female ?? "-"}
                        </div>

                        {/* <small className="text-muted fs-6">Female</small> */}

                        <div className="text-danger fs-6 fw-semibold">
                          {getParticipantData(category)?.total > 0 &&
                            getParticipantData(category)?.female != null
                            ? `${(
                              (getParticipantData(category)?.female /
                                getParticipantData(category)?.total) *
                              100
                            ).toFixed(1)}%`
                            : "-"}
                        </div>
                      </div>

                      {/* <div className="col-4 text-center">
                        <FaUsers size={36} className="text-success mb-2" />

                        <div className="fw-bold fs-5">
                          {getParticipantData(category)?.total ?? "-"}
                        </div>

                        <small className="text-muted fs-6">Total</small>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT SECTION — Coverage NOs. */}
              <div className="col-4 d-flex">
                <div
                  className="card-custom d-flex flex-column p-3 flex-fill"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.7)",
                    borderRadius: "10px",
                  }}
                >
                  {/* Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                      <FaUsers size={40} className="me-3" style={{ color: "#f7b305" }} />
                      <h6 className="fw-bold mb-0">{headerTitle}</h6>
                    </div>

                    {/* Dropdown - Only show for types that have hardcoded data
                    <select
                      className="form-select w-auto"
                      value={selected}
                      onChange={(e) => {
                        setSelected(e.target.value);
                        // Also update the category when dropdown changes
                        if (e.target.value === "awareness") {
                          setCategory("Awareness Meeting");
                        } else if (e.target.value === "cluster") {
                          setCategory("Cluster Training");
                        }
                      }}
                    >
                      <option value="awareness">Awareness Meeting</option>
                      <option value="cluster">Cluster Training</option>
                    </select>*/}
                  </div>

                  {/* Dynamic Content - Only show for specific types */}
                  <div className="mt-2 flex-grow-1">
                    {(category === "Awareness Meeting" || category === "Cluster Training" || category === "Exposure Visit" || category === "Farmer Field Days") ? (
                      dataToShow.length > 0 ? (
                        dataToShow.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between border-bottom py-2"
                          >
                            <span className="fw-semibold">{item.subtype}</span>
                            <span className="fw-bold" style={{ color: "#ed781b" }}>
                              {item.value}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-4">
                          No breakdown data available for {category}
                        </div>
                      )
                    ) : (
                      <div className="text-center text-muted py-4">
                        No additional breakdown available for {category}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card shadow-lg p-4 w-100 h-100 border-0"
        style={{
          background: "linear-gradient(135deg, #e3f8d7, #f9fff2)",
          borderRadius: "20px",
        }}
      >
        <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
          Seed and Grain Market Linkages
        </h2>

        <div className="row g-4">
          {seedgraindata ? (
            [
              // ----- BS-FS CARD -----
              (() => {
                const bsfs = seedgraindata.seed?.find(item => item.seedtype === "BS-FS");
                return {
                  title: "BS-FS",
                  qty: `${bsfs?.totalsurplusqty ?? 0} q`,
                  sale: `₹ ${(bsfs?.totalsellprice ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
                };
              })(),

              // ----- FS-CS CARD -----
              (() => {
                const fscs = seedgraindata.seed?.find(item => item.seedtype === "FS-CS");
                return {
                  title: "FS-CS",
                  qty: `${fscs?.totalsurplusqty ?? 0} q`,
                  sale: `₹ ${(fscs?.totalsellprice ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
                };
              })(),

              // ----- GRAIN CARD -----
              (() => {
                const grain = seedgraindata.grain?.[0];
                return {
                  title: "GRAIN",
                  qty: `${grain?.totalsurplusqty ?? 0} q`,
                  sale: `₹ ${(grain?.totalSell ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
                };
              })()
            ].map((item, index) => (
              <div key={index} className="col-4">
                <div
                  className="p-4 shadow-lg h-100"
                  style={{
                    borderRadius: "18px",
                    background: "rgba(255, 255, 255, 0.4)",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.6)",
                    textAlign: "center",
                    transition: "0.4s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <div className="mb-2">
                    <i
                      className="fas fa-seedling"
                      style={{ fontSize: "38px", color: "#03763f" }}
                    ></i>
                  </div>

                  <div className="fw-bold text-success fs-5 mb-2">{item.title}</div>

                  <div className="fw-bold mb-1" style={{ fontSize: "15px", color: "#2f2f2f" }}>
                    Quantity :
                    <span className="fw-bold" style={{ color: "#0b6cbc" }}>
                      {item.qty}
                    </span>
                  </div>

                  <div className="fw-bold" style={{ color: "#ed781b", fontSize: "17px" }}>
                    Sale Value : {item.sale}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <div className="text-muted">{loading ? "Loading..." : "No seed/grain data available"}</div>
            </div>
          )}
        </div>

      </div>
      {/* <div className="row d-flex">
        <div className="col-12 d-flex flex-column gap-4">
          <div style={{
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 160px)"
          }}>
            <div style={{
              backgroundColor: "#ffffff",
              borderBottom: "3px solid #007bff",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
            }}>
              <div className="container-fluid">
                <div className="d-flex justify-content-center align-items-center py-3 px-4">
                  <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
              Seed market linkage by PGs
            </h2>
                </div>
              </div>
            </div>

            <div style={{
              flex: "1",
              overflowY: "auto",
              overflowX: "auto"
            }}>
              <div className="table-responsive">
                <table className="table table-hover mb-0" style={{
                  minWidth: "2000px",
                  backgroundColor: "#fff"
                }}>
                  <thead style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    position: "sticky",
                    top: "0",
                    zIndex: "10"
                  }}>
                    <tr>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>District</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>FPC</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>Crop</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>Season</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px"
                      }}>Variety</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "100px"
                      }}>Class</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Producer Group (no.)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px",
                        textAlign: "center"
                      }}>Farmer (no.)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px",
                        textAlign: "center"
                      }}>Total Qty (q)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "100px",
                        textAlign: "center"
                      }}>MSP (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Value @MSP (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Sale Price per q (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Total Sale Value (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "160px",
                        textAlign: "center"
                      }}>Incremental Value per q (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "180px",
                        textAlign: "center"
                      }}>Total Incremental Value (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Linkage to OSSC (q)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Linkage to Others (q)</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "13px" }}>
                    {seedData.map((row, i) => (
                      <tr key={i} style={{
                        backgroundColor: i % 2 === 0 ? "#f8f9fa" : "#ffffff",
                        borderBottom: "1px solid #dee2e6"
                      }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#e3f2fd";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = i % 2 === 0 ? "#f8f9fa" : "#ffffff";
                        }}>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.district}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.fpc || "NA"}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.crop}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.season}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.variety}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.clazz}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.producerGroupCount}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.farmerCount}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.surplusQuantity}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.msp?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.value?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.salePricePerQuantity?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.totalSale?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.incrementalValuePerQuantity?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.totalIncrementalValue?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.linkageToOssc}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057"
                        }}>{row.linkageToOthersAgency}</td>
                      </tr>
                    ))}
                    {seedData.length > 0 && (
                      <tr style={{ fontWeight: "bold", background: "#f8f9fa" }}>
                        <td colSpan={10} style={{
                          padding: "12px 8px",
                          textAlign: "end",
                          borderRight: "1px solid #dee2e6"
                        }}>
                          Total
                        </td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{seedTotals.value?.toLocaleString()}</td>
                        <td style={{ borderRight: "1px solid #dee2e6" }}></td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{seedTotals.totalSale?.toLocaleString()}</td>
                        <td style={{ borderRight: "1px solid #dee2e6" }}></td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{seedTotals.totalIncrementalValue?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{seedTotals.linkageToOssc}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center"
                        }}>{seedTotals.linkageToOthersAgency}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {seedData.length === 0 && (
                  <div className="text-center p-4 text-muted">
                    No seed data available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* ===== ACHIEVEMENTS & IMPACT SECTION ===== */}
<div className="row g-3 mb-3">
  {/* ACHIEVEMENTS CARD */}
  <div className="col-6">
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        border: "2px solid #e8f5e9",
        overflow: "hidden",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.12)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "#03763f",
          padding: "20px",
          color: "white",
          borderBottom: "3px solid #02563a",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <i
            className="fas fa-trophy"
            style={{ fontSize: "28px", color: "#ffd700" }}
          ></i>
          <h3 style={{ margin: 0, fontSize: "22px", fontWeight: "bold" }}>
            Key Achievement 
          </h3>
        </div>
      </div>

      {/* Content with Scrollbar */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "25px",
          minHeight: "400px",
          maxHeight: "500px",
          backgroundColor: "#fafafa",
          scrollBehavior: "smooth",
        }}
        className="custom-scrollbar"
      >
        {seedData && seedData.trim() ? (
          <div
            style={{
              fontSize: "15px",
              lineHeight: "1.9",
              color: "#333",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
            dangerouslySetInnerHTML={{ __html: seedData }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#999",
              fontSize: "16px",
              fontStyle: "italic",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <i
                className="fas fa-inbox"
                style={{ fontSize: "48px", marginBottom: "12px", opacity: 0.5 }}
              ></i>
              <p>No achievements data available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>

  {/* IMPACT CARD */}
  <div className="col-6">
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        border: "2px solid #e3f2fd",
        overflow: "hidden",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.12)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "#ed781b",
          padding: "20px",
          color: "white",
          borderBottom: "3px solid #0a4a8a",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <i
            className="fas fa-chart-line"
            style={{ fontSize: "28px", color: "#ffeb3b" }}
          ></i>
          <h3 style={{ margin: 0, fontSize: "22px", fontWeight: "bold" }}>
            Impact
          </h3>
        </div>
      </div>

      {/* Content with Scrollbar */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "25px",
          minHeight: "400px",
          maxHeight: "500px",
          backgroundColor: "#fafafa",
          scrollBehavior: "smooth",
        }}
        className="custom-scrollbar1"
      >
        {grainData && grainData.trim() ? (
          <div
            style={{
              fontSize: "15px",
              lineHeight: "1.9",
              color: "#333",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
            dangerouslySetInnerHTML={{ __html: grainData }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#999",
              fontSize: "16px",
              fontStyle: "italic",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <i
                className="fas fa-inbox"
                style={{ fontSize: "48px", marginBottom: "12px", opacity: 0.5 }}
              ></i>
              <p>No impact data available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

{/* Custom Scrollbar CSS */}
<style>{`
  .custom-scrollbar::-webkit-scrollbar {
    width: 8px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    borderRadius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #03763f;
    borderRadius: 10px;
    transition: background 0.3s ease;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #02563a;
  }

  .custom-scrollbar1::-webkit-scrollbar {
    width: 8px;
  }
  
  .custom-scrollbar1::-webkit-scrollbar-track {
    background: #f1f1f1;
    borderRadius: 10px;
  }
  
  .custom-scrollbar1::-webkit-scrollbar-thumb {
    background: #ed781b;
    borderRadius: 10px;
    transition: background 0.3s ease;
  }
  
  .custom-scrollbar1::-webkit-scrollbar-thumb:hover {
    background: #92480b;
  }
`}</style>



      {/* <div className="row d-flex mt-3">
        <div className="col-12 d-flex flex-column gap-4">
          <div style={{
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 160px)"
          }}>
            <div style={{
              backgroundColor: "#ffffff",
              borderBottom: "3px solid #007bff",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
            }}>
              <div className="container-fluid">
                <div className="d-flex justify-content-center align-items-center py-3 px-4">
                  <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
              Grain market linkage by PGs
            </h2>
                </div>
              </div>
            </div>

            <div style={{
              flex: "1",
              overflowY: "auto",
              overflowX: "auto"
            }}>
              <div className="table-responsive">
                <table className="table table-hover mb-0" style={{
                  minWidth: "1400px",
                  backgroundColor: "#fff"
                }}>
                  <thead style={{
                    backgroundColor: "#007bff",
                    color: "white",
                    position: "sticky",
                    top: "0",
                    zIndex: "10"
                  }}>
                    <tr>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>District</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>Crop</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px"
                      }}>Season</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Producer Group (no.)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px",
                        textAlign: "center"
                      }}>Farmer (no.)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "120px",
                        textAlign: "center"
                      }}>Total Qty (q)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "100px",
                        textAlign: "center"
                      }}>MSP (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Value @MSP (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Sale Price per q (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "140px",
                        textAlign: "center"
                      }}>Total Sale (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        minWidth: "160px",
                        textAlign: "center"
                      }}>Incremental Value per q (₹)</th>
                      <th style={{
                        padding: "15px 12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        minWidth: "180px",
                        textAlign: "center"
                      }}>Total Incremental Value (₹)</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "13px" }}>
                    {grainData.map((row, i) => (
                      <tr key={i} style={{
                        backgroundColor: i % 2 === 0 ? "#f8f9fa" : "#ffffff",
                        borderBottom: "1px solid #dee2e6"
                      }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#e3f2fd";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = i % 2 === 0 ? "#f8f9fa" : "#ffffff";
                        }}>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.district}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.crop}</td>
                        <td style={{
                          padding: "12px 8px",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.season}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.producerGroupCount}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.farmerCount}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.surplusQuantity}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.msp?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.costOfProduceAtMsp?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.salePricePerQuantity?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.totalSale?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057",
                          borderRight: "1px solid #dee2e6"
                        }}>{row.incrementalValuePerQtl?.toLocaleString()}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          color: "#495057"
                        }}>{row.totalIncrementalValue?.toLocaleString()}</td>
                      </tr>
                    ))}

                    {grainData.length > 0 && (
                      <tr style={{ fontWeight: "bold", background: "#f8f9fa" }}>
                        <td colSpan={3} style={{
                          padding: "12px 8px",
                          textAlign: "end",
                          borderRight: "1px solid #dee2e6"
                        }}>
                          Total
                        </td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{grainTotals.producerGroupCount}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{grainTotals.farmerCount}</td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{grainTotals.surplusQuantity}</td>
                        <td style={{ borderRight: "1px solid #dee2e6" }}></td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{grainTotals.costOfProduceAtMsp?.toLocaleString()}</td>
                        <td style={{ borderRight: "1px solid #dee2e6" }}></td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center",
                          borderRight: "1px solid #dee2e6"
                        }}>{grainTotals.totalSale?.toLocaleString()}</td>
                        <td style={{ borderRight: "1px solid #dee2e6" }}></td>
                        <td style={{
                          padding: "12px 8px",
                          textAlign: "center"
                        }}>{grainTotals.totalIncrementalValue?.toLocaleString()}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {grainData.length === 0 && (
                  <div className="text-center p-4 text-muted">
                    No grain data available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div> */}


      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card-custom p-3 shadow-sm flex-fill d-flex flex-column">
            <h2 className="text-center fw-bold text-success mb-4" style={{ fontSize: "26px" }}>
              Visual Evidence
            </h2>
            <div className="card-body p-0">
              <div className="row px-2">
                {verifiedImg && verifiedImg.length > 0 && (
                  <div className="col-md-2  d-flex flex-column align-items-center" style={{ borderRight: "2px solid #ddd" }}>
                    <ul style={{ listStyle: "none", padding: "0" }}>
                      {verifiedImg.map((category, index) => (
                        <li
                          key={index}
                          onClick={() => setSelectedCategory(category)}
                          style={{
                            padding: "10px",
                            fontSize: "16px",
                            color: selectedCategory?.name === category.name ? "#007bff" : "#333",
                            fontWeight: selectedCategory?.name === category.name ? "bold" : "normal",
                            cursor: "pointer",
                            textDecoration: selectedCategory?.name === category.name ? "underline" : "none",
                          }}
                        >
                          {category.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {!selectedCategory ? (
                  <div className="col-md-12 mt-2 mb-2">
                    <p className="text-danger text-center fw-bold">No images available</p>
                  </div>
                ) : selectedCategory.images.length === 0 ? (
                  <div className="col-md-12 mt-2 mb-2">
                    <p className="text-danger text-center fw-bold">No images available</p>
                  </div>
                ) : (
                  <div className="col-md-10 mt-2 mb-2">
                    <h4 style={{ marginBottom: "15px", fontWeight: "bold", color: "#333" }}>
                      {selectedCategory?.name}
                    </h4>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        alignItems: "stretch", // Ensures all images in a row have the same height
                      }}
                    >

                      {selectedCategory && selectedCategory.images.map((imgObj, index) => (
                        <div key={index} style={{ flex: "1 1 auto", minWidth: "150px" }}>
                          <img
                            src={IMG_URL + imgObj.url}
                            alt={`Image ${index}`}
                            onClick={() => openLightbox(imgObj.url, imgObj.location, imgObj.date, index)}
                            style={{
                              width: "100%",
                              height: "200px", // Fixed row height
                              objectFit: "cover", // Ensures the image covers the container while maintaining aspect ratio
                              borderRadius: "5px",
                              transition: "transform 0.3s ease-in-out",
                              cursor: "pointer",
                            }}
                            onMouseOver={(e) => (e.target.style.transform = "scale(1.02)")}
                            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {lightbox.open && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          style={{ background: "rgba(0, 0, 0, 0.9)", zIndex: 1050 }}
        >
          {/* Close Button */}
          <button
            className="position-absolute top-0 end-0 btn btn-danger"
            onClick={closeLightbox}
          >
            ✖
          </button>

          {/* Left Navigation Arrow */}
          <button
            className="position-absolute start-0 top-50 translate-middle-y btn"
            onClick={() => changeImage(-1)}
            style={{ fontSize: "24px", padding: "10px 15px" }}
          >
            <span
              style={{
                color: "gray",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "white")} // White on hover
              onMouseLeave={(e) => (e.target.style.color = "gray")} // Gray when mouse leaves
            >←</span>
          </button>

          {/* Main Selected Image */}
          <img
            src={IMG_URL + lightbox.image}
            alt="Selected"
            className="border border-light"
            style={{
              height: "calc(100vh - 250px)", // Adjusted height
              width: "auto",
              maxWidth: "90%",
              objectFit: "contain",
              transition: "transform 0.3s ease-in-out",
            }}
          />
          <div className="text-center text-white fw-bold mt-2">
            Image {lightbox.index + 1} of {selectedCategory.images.length}
            <p className='mb-0'>Location : {lightbox.location} </p>
            <p>Date : {lightbox.date ? format(parseISO(lightbox.date), "dd-MM-yyyy") : "N/A"} </p>
          </div>



          {/* Right Navigation Arrow */}
          <button
            className="position-absolute end-0 top-50 translate-middle-y btn"
            onClick={() => changeImage(1)}
            style={{ fontSize: "24px", padding: "10px 15px" }}
          >
            <span
              style={{
                color: "gray",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "white")} // White on hover
              onMouseLeave={(e) => (e.target.style.color = "gray")} // Gray when mouse leaves
            >→</span>
          </button>

          {/* Thumbnails - Centered at Bottom */}
          <div
            className="position-absolute bottom-0 w-100 d-flex justify-content-center py-3"
            style={{ background: "rgba(0, 0, 0, 0.6)" }}
          >
            {selectedCategory.images.map((thumb, index) => (
              <img
                key={index}
                src={IMG_URL + thumb.url}
                alt={`Thumbnail ${index}`}
                onClick={() => setLightbox({ ...lightbox, image: thumb.url, location: thumb.location, date: thumb.date, index })}
                style={{
                  width: "80px",
                  height: "60px",
                  margin: "5px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  border: lightbox.index === index ? "3px solid green" : "2px solid white",
                  objectFit: "cover",
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Index;